// extracted by mini-css-extract-plugin
export default {"root":"HistogramChart_root__jpmax","summary":"HistogramChart_summary__UxxxS","label":"HistogramChart_label__tHUJR","table":"HistogramChart_table__Xt7Gj"};